// extracted by mini-css-extract-plugin
module.exports = {"logoImage":"mobileMenu_logoImage__2Hxwu"};